module.exports = " <li class=nav-item v-if=googleOauthConnected> <a class=nav-link href=# @click.prevent=logout>Se déconnecter</a> </li> <li class=nav-item v-else> <a class=nav-link href=# @click.prevent=login>Se connecter</a> </li> <li class=nav-item v-if=googleOauthConnected style=\"color: green\"> <span class=nav-link>Connecté</span> </li> <li class=nav-item v-else style=\"color: red\"> <span class=nav-link>Pas connecté</span> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/google/Login.vue
// module id = 496
// module chunks = 1